// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__16qWE","fullScreen":"style_fullScreen__2NGgo","hidden":"style_hidden__1OXZq"};